<template>
  <div class="wrapper">
    <div class="top">
      <div class="content">
        <img class="logo" src="../../assets/contact_aimore.png" />
        
        <div class="title">
          <h2>一站式研发-运营-销售</h2>
          <h2>的IoT生态赋能</h2>
        </div>

        <p class="subtitle">大于AI+IoT开发者平台 全球领先的IoT云平台</p>
      </div>
    </div>

    <el-form :model="form" :rules="rules" ref="ruleForm" label-position="top">
      <div class="form-title">
        <h2>立即完善信息，</h2>
        <h2>为您提供专属服务！</h2>
      </div>
      <el-form-item label="您的公司名称" prop="company">
        <el-input v-model="form.company" maxlength="64" placeholder="请填写您的公司名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="您的姓名" prop="name">
        <el-input v-model="form.name" maxlength="32" placeholder="请填写您的姓名" clearable></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone">
        <el-input v-model="form.phone" maxlength="32" placeholder="便于我们工作人员与您联系" clearable></el-input>
      </el-form-item>
      <el-form-item label="合作方式及需求" prop="demand">
        <el-input v-model="form.demand" maxlength="256" placeholder="提出您的需求，以便于我们工作人员回复您" clearable></el-input>
      </el-form-item>
      <el-form-item label="您司所在地" prop="addr">
        <el-input v-model="form.addr" maxlength="128" placeholder="便于我们工作人员与您联系" clearable></el-input>
      </el-form-item>
      <el-form-item label="留言" prop="remark">
        <el-input v-model="form.mes" maxlength="256" type="textarea" :rows="2" placeholder="请简单描述您的具体需求" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="valid" :loading="loading">立即提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
  data() {
    const validator = (rule, value, callback) => {
      if (/^[\d-]{6,}$/.test(value)) {
        callback()
      } else {
        callback(new Error('联系电话格式不正确'))
      }
    }
    return {
      rules: {
        company: [ { required: true, message: '请填写您的公司名称', trigger: 'blur' } ],
        name: [ { required: true, message: '请填写您的姓名', trigger: 'blur' } ],
        phone: [ { required: true, message: '请填写您的联系电话', trigger: 'blur' }, { validator, trigger: 'blur'} ],
        demand: [ { required: true, message: '请填写合作方式与需求', trigger: 'blur' } ],
        addr: [ { required: true, message: '请填写您的公司所在地', trigger: 'blur' } ],
      },

      form: {
        company: '',
        name: '',
        phone: '',
        demand: '',
        addr: '',
        mes: ''
      },

      loading: false
    }
  },
  methods: {
    valid() {
      this.$refs.ruleForm.validate(valid => {
        console.log('valid:', valid)
        if (valid) {
          this.submit()
        }
      })
    },
    submit() {
      console.log(this.form)
      this.form.mes = this.form.mes || '--'
      this.form.email = 'luoduan@aimore.com'
      this.loading = true
      axios({
        url: 'https://dev.aimore.com/customer/insert',
        method: 'POST',
        data: qs.stringify(this.form)
      }).then(ret => {
        console.log('ret:', ret)
        this.$alert('提交成功')
        this.form.company = ''
        this.form.name = ''
        this.form.phone = ''
        this.form.demand = ''
        this.form.addr = ''
        this.form.mes = ''
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.top {
  height: 0;
  width: 100%;
  padding-top: 81.32%;
  background-image: url('../../assets/contact.png');
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;

  .content {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    color: #FFF;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .logo {
    position: absolute;
    top: 18.1%;
    width: 32.26%;
  }

  .title {
    position: absolute;
    top: 44.57%;
    text-align: center;
    
    h2 {
      font-weight: 500;
    }
  }

  p {
    font-size: 12px;
    top: 72.13%;
    position: absolute;
    color: rgba(255,255,255,.7);
    padding: 4px 8px;
    border: 1px solid currentColor;
  }
}

.el-form {
  padding: 0 36px;
  margin-bottom: 36px;

  .form-title {
    margin: 28px 0 24px;
    text-align: center;
    h2 {
      font-weight: 500;
    }

    h2 + h2 {
      margin-top: 6px;
    }
  }

  .el-form-item {
    & /deep/ .el-form-item__label {
      line-height: 1;
      padding-bottom: 12px;
    }

    .el-input {
      border-radius: 2px;
      & /deep/ input {
        border-radius: 2px;
      }
    }
  }

  .el-button {
    width: 100%;
    border-radius: 2px;
  }
}
</style>
